export default "__VITE_ASSET__c695d6e5__"